module.exports = __webpack_public_path__ + "img/324.5ff64dc0.jpg";